module.exports = __webpack_public_path__ + "img/high-security-prison.a6cace8a.jpg";